import type { InferOutput } from 'valibot'
import { array, boolean, literal, nullish, number, object, pipe, string, transform } from 'valibot'
import { commonSchema } from './common'
import { bodytext } from '#shared/utils/solr-fields'

const AUTHOR_FALLBACK_IMAGE = 'https://res.cloudinary.com/dylsvi3ok/image/upload/w_500,c_scale/v1604262159/place-holder/portrait_placeholder-500px-24ab9393e5333ef6db041154260559b0-removebg-preview_egqrjh.png'

/**
 * Schema for Solr author response
 */
export const baseAuthorSchema = object({
  ...commonSchema.entries,
  bodytext,
  shortBio: nullish(string()),
  remoteId: nullish(string()),
  image: nullish(array(string())),
  firstname: nullish(string()),
  education: nullish(string()),
  surname: nullish(string()),
  featured: nullish(boolean()),
  nodeType: nullish(literal('author')),
  legal_areas: nullish(array(string())),
  ezObjectId: nullish(array(number())),
})

export type BaseAuthor = InferOutput<typeof baseAuthorSchema>

/**
 * Schema for transformed Author object
 */
export const authorSchema = pipe(
  baseAuthorSchema,
  transform((it) => {
    const { title, remoteId, image, legal_areas, ezObjectId, ...rest } = it

    return {
      ...rest,
      name: title || '',
      slug: remoteId,
      image: image?.[0] || AUTHOR_FALLBACK_IMAGE,
      bio: it.shortBio || '',
      legalAreas: legal_areas || [],
      ezObjectId: ezObjectId?.[0],
    }
  }),
)

export type Author = InferOutput<typeof authorSchema>
